









import NoUISlider from '@/components/NoUISlider.vue'

export default
    components: { NoUISlider }

    computed:
        year:
            get: ->
                return [@$store.state.display.year]
            set: (values) ->
                @$store.commit('display/SET_YEAR', values[0])

    created: ->
        year_min = @$store.state.filter.range.year.lower_bound
        year_max = @$store.state.filter.range.year.upper_bound
        values = (x for x in [year_min..year_max] by 5)

        @config =
            animate: false
            tooltips: true
            step: 1
            pips:
                mode: 'values'
                values: values
                density: 1
            range:
                'min': year_min
                'max': year_max
            direction: 'rtl'
            format:
                to: (value) ->
                    return parseInt(value)
                from: (value) ->
                    return Number(value)
